import axios from 'axios'

export default axios.create({
  baseURL: 'https://guarded-plateau-45330.herokuapp.com/',
})
